// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__CoRpd","mainSearch":"Main_main-search__kqhgm","mainUser":"Main_main-user__Ijorp"};